<template>
    <div>
        <div class="content-container p-0 mt-5 pt-5">
      <img src="@/assets/people/page-500.png" style="width:450px" />
      <slot name="content">
        <h6 class="text-danger h6-lg">
          <i
            class="la la-warning la-lg text-danger"
            style="font-size:27px;position: relative;top: 2px;"
          ></i>
         {{message}}
        </h6>
      </slot>
      <br />
      <hr style="border:none" />
    </div>
    </div>
</template>
<script>
export default {
    props: {
    message: {},
  },
}
</script>